import apiClient from '@/apiClient'

export function useCustomerExport() {
  const exportAccountCsv = async (customerId: string, filename: string) => {
    const res = await apiClient.get(`/customers/${customerId}/account/export`, {
      responseType: 'blob',
    })

    const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' })
    const url = window.URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()

    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  }

  return { exportAccountCsv }
}
